export const SHOW_EVENT = 'SHOW_EVENT';
export const SUCCESS_EVENT = 'SUCCESS_EVENT';
export const CANCEL_EVENT = 'CANCEL_EVENT';
export const SOFTWARE_BACKLOG_ISSUE_TRANSITION = 'software-backlog-issue-transition';
